export default __webpack_public_path__ + "static/media/Flag_of_Germany.67bf05d4.svg";